import { render, staticRenderFns } from "./createSimpleTask.vue?vue&type=template&id=0d833dc0&"
import script from "./createSimpleTask.vue?vue&type=script&lang=js&"
export * from "./createSimpleTask.vue?vue&type=script&lang=js&"
import style0 from "./createSimpleTask.vue?vue&type=style&index=0&id=0d833dc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports